import { ILegacyCartEntry } from '@rbi-ctg/menu';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { LoyaltyAppliedOffer } from 'state/loyalty/types';

import { IAppliedRewards, ICartEntryAdapter, IEntriesIdsMap } from '../types';

// Creates a flat map of all cart entries with sanityId property as key
export const flattenEntriesToMap: (
  acc: IEntriesIdsMap,
  entry: ICartEntryAdapter
) => IEntriesIdsMap = (acc: IEntriesIdsMap, entry: ICartEntryAdapter) => ({
  ...acc,
  [entry.sanityId]: true,
  ...entry.children?.reduce(flattenEntriesToMap, {}),
});

type ParseEntryConfig =
  | { type: LoyaltyPromotionType.OFFER; incentivesToExclude?: IAppliedRewards | null }
  | { type: LoyaltyPromotionType.REWARD; incentivesToExclude?: LoyaltyAppliedOffer[] | null }
  | { type: LoyaltyPromotionType.SYSTEMWIDE_PROMOTION; incentivesToExclude?: never };

// Function maps from ILegacyCartEntry to ICartEntryAdapter to send entries to BE
// Also filters entries that have a reward applied
export const parseEntry = (config: ParseEntryConfig) => {
  const reducer = (
    acc: ICartEntryAdapter[],
    { _id, cartId, price = 0, quantity = 1, children = [] }: ILegacyCartEntry
  ): ICartEntryAdapter[] => {
    if (config.type === LoyaltyPromotionType.OFFER) {
      const rewardApplied = config.incentivesToExclude?.[cartId];
      if (rewardApplied?.timesApplied === quantity) {
        return acc;
      }
    } else if (config.type === LoyaltyPromotionType.REWARD) {
      const offerApplied = config.incentivesToExclude?.find(offer => offer.cartId === cartId);
      if (offerApplied) {
        return acc;
      }
    }

    const parsed: ICartEntryAdapter = {
      sanityId: _id,
      lineId: cartId,
      price,
      quantity,
    };
    if (children.length) {
      parsed.children = children.reduce(reducer, []);
    }
    return [...acc, parsed];
  };
  return reducer;
};
